<h3 mat-dialog-title>{{ data.upload.filename }}</h3>
<mat-dialog-content *ngIf="data.url">
  <a [href]="url" target="_blank">Open on another tab</a>
  <img *ngIf="isImage" [src]="url" alt="{{ data.upload.filename }}" class="object-contain size-full min-h-50vh" />
  <object *ngIf="!isImage" [data]="url" type="application/pdf" class="object-contain size-full min-h-50vh"></object>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>
